import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a0be956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-item dropdown" }
const _hoisted_2 = {
  id: "swctrlLang",
  class: "nav-link dropdown-toggle",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_3 = { class: "span-language" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "span-language span-language-opt" }

import {languagesLst} from '@/i18n';

import jsonLangEsDefault from '@/locales/es.json';
import jsonLangEnDefault from '@/locales/en.json'; 
import moment from 'moment'; 
import { usePrimeVue } from "primevue/config";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSwitchComponent',
  props: {
    isMenuMobile: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {



  const primevue = usePrimeVue();
const GetCurrentLanguage = (current:any) => 
{
  if(!current && !current.locale)return null
  return  languagesLst.find(c => c.id === current.locale );
}
const ChangeLanguage=(lang: any)=>
{  
  moment.locale(lang.id);  
  switch(lang.id)
  {
    case 'es-mx':
      primevue.config.locale = {...jsonLangEsDefault.prime};
      break;
    case 'en-us': 
      primevue.config.locale = {...jsonLangEnDefault.prime};
      break;
  }
  
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(GetCurrentLanguage(_ctx.$i18n)?.title), 1)
    ]),
    _createElementVNode("ul", {
      class: _normalizeClass(["dropdown-menu", {'drop-menu-tool-r-mobil': __props.isMenuMobile , 'drop-menu-tool-r':!__props.isMenuMobile}]),
      "aria-labelledby": "swctrlLang"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languagesLst), (lang) => {
        return (_openBlock(), _createElementBlock("li", {
          key: lang?.id
        }, [
          (lang.id !== _ctx.$i18n.locale)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "dropdown-item",
                onClick: ($event: any) => {{_ctx.$i18n.locale = lang.id;ChangeLanguage(lang)}}
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass('Idioma ' + lang.logo)
                }, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(lang.id + ' ' + lang.title), 1)
                ], 2)
              ], 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 2)
  ]))
}
}

})